import React, { useEffect, useState } from 'react'
import { Button, Menu, MenuItem, ListItemIcon, Typography } from '@mui/material'
import { useGetIdentity, useLocaleState, useTranslate } from 'react-admin'
import LanguageIcon from '@mui/icons-material/Language'
import { userServices } from 'src/services/auth/user/user.service'

export const LanguageSelector = () => {
  const translate = useTranslate()
  const [locale, setLocale] = useLocaleState()
  const [anchorEl, setAnchorEl] = useState(null)
  const { identity } = useGetIdentity()
  
  useEffect(() => {
      if (identity?.language){
        setLocale(identity?.language)
      }
  }, [identity?.language])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const updateLanguage = async (language) => {
    try {
      await userServices.changeLanguage(identity?.user_id, { language: language })
    } catch (error) {
      console.log('updateLanguage error', error)
    }
  }

  const handleChange = (locale) => {
    setLocale(locale)
    handleClose()
    localStorage.setItem('language', locale)
    updateLanguage(locale)
    const eventChange = new Event('languageChanged')
    window.dispatchEvent(eventChange)
  }

  return (
    <>
      <Button
        onClick={handleClick}
        startIcon={<LanguageIcon />}
        style={{
          textTransform: 'none',
          justifyContent: 'flex-start',
          width: '100%',
          paddingLeft: '22px',
        }}
      >
        {locale === 'en-US'
          ? translate('ra.language.english')
          : locale === 'es-AR'
          ? translate('ra.language.spanish')
          : translate('ra.language.pt_br')}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem onClick={() => handleChange('en-US')}>
          <ListItemIcon>
            <LanguageIcon fontSize='small' />
          </ListItemIcon>
          <Typography variant='inherit'>{translate('ra.language.english')}</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange('es-AR')}>
          <ListItemIcon>
            <LanguageIcon fontSize='small' />
          </ListItemIcon>
          <Typography variant='inherit'>{translate('ra.language.spanish')}</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange('pt-BR')}>
          <ListItemIcon>
            <LanguageIcon fontSize='small' />
          </ListItemIcon>
          <Typography variant='inherit'>{translate('ra.language.pt_br')}</Typography>
        </MenuItem>
      </Menu>
    </>
  )
}


